import { ArrayHelpers } from 'formik';
import { ProgramAttachment } from '../../types';

export const deleteAttachment = (
  attachments: ProgramAttachment[],
  arrayHelper: ArrayHelpers,
  attachment: ProgramAttachment
) => {
  const idx = attachments.findIndex((x) => x.id === attachment.id);
  if (idx < 0) return;
  if (attachment.status === 'EXISTED') {
    arrayHelper.replace(idx, {
      ...attachment,
      status: 'DELETED',
    });
  } else {
    arrayHelper.remove(idx);
  }
};

export const isVideo = (mimeType: string) => mimeType.startsWith('video/');
